import { useBreadcrumb } from "core/features/breadcrumbs";
import DetalhesGrupo from "./components/DetalhesGrupo/DetalhesGrupo";
import { useLocation, useParams } from "react-router";
import { useState } from "react";
import Container from 'components/Container';

function VerGrupoPage() {
  const params = useParams();
  const state = useLocation().state;

  const { id } = params as { id: string };
  const [nome, setNome] = useState((state as { nome: string })?.nome);

  const name = nome || `Carregando...`;

  useBreadcrumb([
    { name: "Cadastros" },
    { name: "Grupos de Unidades", url: "/cadastros/grupos-unidades" },
    { name },
  ]);

  return (
    <Container>
      <DetalhesGrupo id={id} nome={name} onLoadGrupo={setNome} />
    </Container>
  );
}

export default VerGrupoPage;
